/**************************************************
 CONTROLLER: participantDetailsModalController
**************************************************/
(function(){
    // add the controller
    SUGApp.controller('participantDetailsModalController', participantDetailsModalController);

    participantDetailsModalController.$inject = [ '$scope','$modalInstance','$filter','$templateCache','$location','$q','$timeout','$window','SUGUtilities','sugCacheFactory','errorService','profilePicService','signupPageService','listid','memberId','slotdata','slotitem','theme','tzshort','showprofilepics','shownames','signuptype' ];
    function participantDetailsModalController(    $scope,  $modalInstance, $filter,  $templateCache,  $location,  $q,  $timeout, $window, SUGUtilities,  sugCacheFactory,  errorService,  profilePicService,   signupPageService,  listid,  memberId, slotdata,  slotitem,  theme,  tzshort, showprofilepics, shownames, signuptype ){

        $scope.isProcessing = false;
        $scope.loaded = false;
        $scope.frmObj = {};
        $scope.slotdata = slotdata;
        $scope.slotitem = slotitem;
        $scope.theme = theme;
        $scope.tzshort = tzshort;
        $scope.showprofilepics = showprofilepics;
        $scope.shownames = shownames;
        $scope.themestyles = '';
        $scope.modalParticipants = [];
        $scope.showfullcomment = false;
        $scope.signuptype = signuptype;
        $scope.slotimages = [];

        var ldDeferred , isSending = false;

        /* View Specific Strings */
        $scope.strings = {
            table:   {
                  first:            'First'
                , last:             'Last'
                , quantity:         'Qty'
                , comment:          'Comment'
                , noData:           'There are no participants for this slot item.'
                , noFilteredData:   'No data matched your search criteria. Please try again.'
            }
            , errorDirective:   {
                  errorsTitle:  ''
                , errorsPleaseCorrect:  'Please correct the following issues:'
            }
        };

        //vars used to map data from the different SU models to the front end
        $scope.slotinfo = {
            title:            ''
          , timelabel:        ''
          , imagealttext:     ''
          , datelabel:        {}
          , slotimages:       []
          , locdetail:        {}
        };

        //init error service
        $scope.es = errorService.newInstance();
        $scope.es.init();
        $scope.es.clearErrors();

        //pre-define form model
        $scope.frmObj = {
            searchFilter:       ''
        };

        /* Tooltip vars */
        $scope.popTrig = 'mouseenter';
        $scope.popPlacement = 'top';
        $scope.popDelay = 300;

        /* Pagination */
        $scope.recordCount = 0;
        $scope.pagination = {
            currentPage: 1,
            maxSize: 5,
            numPerPage: 10
        };

        $scope.perPageOptions = [
              {label:'Show', count:0, previouscount:0}
            , {label:'10', count:10, previouscount:0}
            , {label:'25', count:25, previouscount:10}
            , {label:'50', count:50, previouscount:25}
        ];


        // Handler for Processing Status
        $scope.$on('isProcessing', function (event, isProcessing) {
            $scope.isProcessing = isProcessing;

            disableForm(isProcessing);

            if ($scope.isProcessing) {
                SUGUtilities.showLoading('processing');
            }
        });

        //manage disabling the form
        var disableForm = function (blnDisabled) {
            $scope.frmDisableField = blnDisabled;
        };

        // close the modal
        $scope.dismiss = function () {
            $modalInstance.dismiss(false);
        };

        /************************
         SORTING and PAGINATION
        ************************/
        /* Column Direct Sort */
        $scope.setSort = function (columnKey) {
            $scope.frmObj.orderColumn = columnKey;
            $scope.frmObj.direction = !$scope.frmObj.direction;
            $scope.arrowDir = $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            loadData( true ); //force the data to reset
        };

        /* Apply Settings/Filter */
        var filterData = function() {
            if( $scope.loaded ){
                //sorting and filtering is handled on the backend, so just return the entire record set to be paginated below
                $scope.participantsFiltered = angular.copy( $scope.modalParticipants );

                $scope.recordCount = $scope.participantsFiltered.length;

                // Apply Pagination
                if ($scope.participantsFiltered.length) {
                    var begin = ($scope.pagination.currentPage - 1) * parseInt($scope.pagination.numPerPage);
                    var end = begin + parseInt($scope.pagination.numPerPage);
                    $scope.participantsFiltered = $scope.participantsFiltered.slice(begin, end);

                    // If end up with no results, recursively step back until we get valid paged results
                    if (!$scope.participantsFiltered.length && $scope.pagination.currentPage > 1) {
                        $scope.pagination.currentPage--;
                        filterData();
                    }
                }
            }
        };

        /* Prepare Settings/Filter */
        var prepareSettings = function () {
            $scope.settingID = 'settingID' in $scope.frmObj ? $scope.frmObj.settingID : 0;
            if (!('searchFilter' in $scope.frmObj)) {
                $scope.frmObj.searchFilter = '';
            }
            if (!('orderColumn' in $scope.frmObj)) {
                $scope.frmObj.orderColumn = '';
            }
            if (!('direction' in $scope.frmObj)) {
                $scope.frmObj.direction = false;
            }
            if (!('numPerPage' in $scope.frmObj)) {
                $scope.frmObj.numPerPage = 10;
            }
            $scope.arrowDir =  $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
            $scope.pagination.numPerPage = $scope.frmObj.numPerPage;
        };

        /**
         * Function to kick off any initilization steps, such as data loading and setting defaults
         */
        var init = function(){

            //set up vars for use in the UI based on the current sign up type
            switch ($scope.signuptype) {

                case 'calendar' :
                    $scope.slotinfo.title = $scope.slotitem.item;
                    $scope.slotinfo.datalabel = $scope.slotdata.dateLabel;

                    if ( $scope.slotdata.timeLabel.length ) {
                        //timeLabel for Date Sorted/Slots Only is slightly different HTML markup than Slot Sorted
                        $scope.slotinfo.timelabel = $scope.slotdata.timeLabel.replace(/<br>/g,'').replace(/-/g,' -') + '&nbsp;<span class="participant-details--day">' + $scope.tzshort.toUpperCase() + '</span>';
                    }

                    $scope.slotinfo.locdetail = $scope.slotdata.locdetail;
                    $scope.slotinfo.locdetail.location = $scope.slotdata.location;
                    break;

                case 'standard_d' : // date sorted
                case 'nodate':      // slots only
                    if( Object.keys($scope.slotitem.images).length ) {
                        $scope.slotinfo.slotimages = $scope.slotitem.images.images;
                    }
                    $scope.slotinfo.imagealttext = ($scope.slotinfo.slotimages.length) ? ( ($scope.slotitem.images.itemdescription.length) ? $scope.slotitem.images.itemdescription : $scope.slotitem.images.itemname + ' image' ) : '';
                    $scope.slotinfo.title = $scope.slotitem.item;
                    $scope.slotinfo.datalabel = $scope.slotdata.dateLabel;
                    if($scope.signuptype != 'nodate'){
                        if($scope.slotdata.timeLabel.length){
                            //timeLabel for Date Sorted/Slots Only is slightly different HTML markup than Slot Sorted
                            $scope.slotinfo.timelabel = $scope.slotdata.timeLabel.replace(/<br>/g,'').replace(/-/g,' -') + '&nbsp;<span class="participant-details--day">' + $scope.tzshort.toUpperCase() + '</span>';
                        }
                        $scope.slotinfo.locdetail = $scope.slotdata.locdetail;
                        $scope.slotinfo.locdetail.location = $scope.slotdata.location;
                    }
                    break;

                case 'standard_i':  // slot sorted
                    if( Object.keys($scope.slotdata.images).length ) {
                        $scope.slotinfo.slotimages = $scope.slotdata.images.images ;
                    }

                    $scope.slotinfo.imagealttext = ($scope.slotinfo.slotimages.length) ? ( ($scope.slotdata.images.itemdescription.length) ? $scope.slotdata.images.itemdescription : $scope.slotdata.images.itemname + ' image' ) : '';
                    $scope.slotinfo.title = $scope.slotdata.item;
                    if($scope.slotitem.timeLabel.length){
                        //timeLabel for Slot Sorted is slightly different HTML markup than Date Sorted/Slots Only
                        $scope.slotinfo.timelabel = $scope.slotitem.timeLabel.replace(/<br>/g,'').replace(/-/g,' - ') + '&nbsp;<span class="participant-details--day">' + $scope.tzshort.toUpperCase() + '</span>';
                    }
                    $scope.slotinfo.datalabel = $scope.slotitem.dateLabel;

                    $scope.slotinfo.locdetail = $scope.slotitem.locdetail;
                    $scope.slotinfo.locdetail.location = $scope.slotitem.location;
                    break;

                default:
                    break;
            }


            //set the custom styles to match the theme
            $scope.themestyles = generateModalStyles($scope.theme, '.participant-details');

            //loadData() will be run automatically by the pagination watcher, so no need to run it in init()
        };

        /**
         * Used to load the participants data from the back end
         * This function is called by various UI eleemnts for backedn pagination
         */
        var loadData = function( blnForceRefresh ){
            //toggle spinner and form disable
            SUGUtilities.broadCast('isProcessing', true);

            //kill any previous requests to prevent a pile up
            if(isSending) {
                ldDeferred.resolve();
            }
            isSending = true;
            ldDeferred = $q.defer();

            //determine if we are resetting the main array of participants
            if( typeof blnForceRefresh === 'undefined' ){ blnForceRefresh = false; }

            //pre-set the Settings values
            prepareSettings();

            //determine the data range to load; load x10 recoord to buffer enough data for pagination
            var intLastVisibleRow = $scope.pagination.currentPage * $scope.frmObj.numPerPage;
            var intQryRowStart = (intLastVisibleRow - $scope.frmObj.numPerPage) + 1;
            var intQryRowEnd =  $scope.modalParticipants.length + (10 * $scope.frmObj.numPerPage);

            //Make data call if we need to reset the modalParticipants array, or if we don't have enough records in buffer
            if( !$scope.modalParticipants.length || blnForceRefresh || ($scope.modalParticipants.length < $scope.slotitem.participantcount && intLastVisibleRow >= $scope.modalParticipants.length) ){

                //Adjust the offset when we go beyond the first 10 pages so that it doesn't include the previous page of data a 2nd time
                if( $scope.modalParticipants.length && !blnForceRefresh && intQryRowStart > 1 ){
                    var intOffset = intQryRowStart + $scope.frmObj.numPerPage;
                } else {
                    var intOffset = intQryRowStart;
                }

                signupPageService.getSignUpParticipantsBySlotItem({
                      "listid": listid
                    , "slotitemid": $scope.slotitem.slotitemid
                    , "offset":  intOffset
                    , "limitTo": intQryRowEnd
                    , "search": $scope.frmObj.searchFilter
                    , "orderBy": $scope.frmObj.orderColumn
                    , "orderDesc": $scope.frmObj.direction
                    , "memberidViewing": memberId
                }).then(function (response) {
                    if(SUGUtilities.ajaxResultInvalid(response.data)) {
                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessing', false);

                        // invalid response, show error
                        $scope.es.setError('dateSortedParticipantsModal', SUGUtilities.getAjaxResponseMessage(response));
                        isSending = false;
                        } else {
                        //response was valid
                        var r = SUGUtilities.lowerCaseKeys( response.data );

                        if( r.success && Object.keys(r.data).length ){
                            if(!$scope.modalParticipants.length || blnForceRefresh){
                                //if we ran a search or a sort, then reset data array
                                $scope.modalParticipants = r.data.participants;
                            } else {
                                //add new data set to what we already have for forward/backwards pagination
                                var arrCurrentDataSet = angular.copy( $scope.modalParticipants );
                                $scope.modalParticipants = arrCurrentDataSet.concat( r.data.participants );
                            }
                        }
                        isSending = false;
                        $scope.loaded = true;

                        // run the filter
                        filterData();
                    }

                    ldDeferred.resolve($scope.modalParticipants);

                    //toggle spinner and form disable
                    SUGUtilities.broadCast('isProcessing', false);

                    //set focus on the search field
                    setSearchFocus();
                });
            } else {
                //If we don't need to load more backend data then just retunr what we have and filter as usual
                isSending = false;
                $scope.loaded = true;

                filterData();

                ldDeferred.resolve($scope.modalParticipants);

                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessing', false);

                //set focus on the search field
                setSearchFocus();
            } // END backend call

            return ldDeferred.promise;
        };

        /**
         * Utility function to set focus on the search field after data updates
         * Use $timeout for slight delay to allow form time to render
         */
        var setSearchFocus = function() {
            if( $scope.recordCount > $scope.frmObj.numPerPage || $scope.frmObj.searchFilter.length > 0 ){
                $timeout( function(){
                    document.getElementById('filter').focus();
                }, 500 );
            }
        };

        /**
         * Generate and return the dynamic CSS using the passed in sign up theme style values. Used in both the edit and public portal pages.
         * @param {Object} themecss - object containing colors to use in the generated styles
         * @param {String} classContainer - css selector of html element containing all content data
         * @param {String} wrapperSelector - css selector of html element wrapping specific areas of data
         */
        var generateModalStyles = function(themecss, classContainer, wrapperSelector){
            // if we have an empty themecss object return an empty string
            if( SUGUtilities.isUndefinedOrEmptyObject(themecss) ){
                return '';
            }
            classContainer = SUGUtilities.isDefinedNotNullNotEmpty(classContainer) ? classContainer : '';
            wrapperSelector = SUGUtilities.isDefinedNotNullNotEmpty(wrapperSelector) ? wrapperSelector : '';

            //generate the styles
            var themeStyles = '';

            //modal background
            if( themecss.backgroundcolor.length || themecss.backgroundimage.length){
                themeStyles += classContainer + ' .white-popup {';
                if( themecss.backgroundcolor.length ){ themeStyles += 'background-color: ' + themecss.backgroundcolor + ' !important; '; }
                if( themecss.backgroundimage.length ){ themeStyles += 'background-image: url("/images/theme/' + themecss.backgroundimage.split(/[/]+/).pop() + '") !important; '; }
                themeStyles += ' } ';
            }

            //modal title
            if( themecss.textcolor2.length ){
                themeStyles += classContainer + ' .participant-details--title { color: ' + themecss.textcolor2 + ' !important; font-weight:500; margin-bottom: 2px !important; }';
            }

            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' .participant-details--date-time { color: ' + themecss.textcolor1 + '; font-weight:500; }';
                themeStyles += classContainer + ' .participant-details--day { color: ' + themecss.textcolor1 + '; font-weight:normal; font-size: 94%; }';
            }

            themeStyles += classContainer + ' .participant-details--loc-name { font-size: 96%; }';

            //modal-close
            if( themecss.buttoncolor.length ){
                themeStyles += classContainer + ' button.modal-close { color: ' + themecss.textcolor2 + ' !important; }';
            }

            //slot image
            themeStyles += classContainer + ' .participant-details--slot-image { max-height:110px; border-radius: 6px; margin-bottom: 8px; ';
            if( themecss.tableheaderbackground.length ){
                themeStyles += ' border:1px solid ' + themecss.tableheaderbackground + '; }';
            } else {
                themeStyles += '}';
            }

            //table
            themeStyles += classContainer + ' .sTable, .sTableSmall {margin-bottom: 8px;}';
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' table .table, .sTable, .sTableSmall { border-top: 3px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-right: 1px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-bottom: 3px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-left: 1px solid ' + themecss.textcolor1 + '; ';
                themeStyles += '}';
            }

            //hyperlinks in the table
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' table a, .sTable a, .sTableSmall a { color: ' + themecss.textcolor1 + '; text-decoration: underline; }';
                themeStyles += classContainer + ' table a.small, .sTable a.small, .sTableSmall a.small { font-size: 0.85em; }';
            }

            //table thead
            themeStyles += classContainer + ' table thead { ';
            if( themecss.tableheaderbackground.length ){ themeStyles += ' background-color: ' + themecss.tableheaderbackground + ' !important; '; }
            if( themecss.tableheadertext.length ){ themeStyles += ' color: ' + themecss.tableheadertext + ' !important; '; }
            if( themecss.tableheaderimage.length ){ themeStyles += ' background-image: url(' + themecss.tableheaderimage + ') !important; '; }
            themeStyles += '}';

            //table thead links
            if( themecss.tableheadertext.length ){
                themeStyles += classContainer +
                    ' .sTableSmall thead>tr>th a:not(.btn),' +
                    ' .sTableSmall thead>tr>th a:hover:not(.btn),' +
                    '.sTableSmall thead>tr>th a:focus:not(.btn),' +
                    '.sTableSmall thead>tr>th a:active:not(.btn),' +
                    '.sTableSmall thead>tr>th a:visited:not(.btn),' +
                    '.sTable thead>tr>th a:not(.btn),' +
                    '.sTable thead>tr>th a:hover:not(.btn),' +
                    '.sTable thead>tr>th a:focus:not(.btn),' +
                    '.sTable thead>tr>th a:active:not(.btn),' +
                    '.sTable thead>tr>th a:visited:not(.btn) {' +
                        'color: ' + themecss.tableheadertext + ' !important; ' +
                        'text-decoration: none; ' +
                    '}';
            }

            //table rows
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' table.table tbody tr td { border-bottom:1px solid  ' + themecss.textcolor1 + '; color: ' + themecss.textcolor1 + '; ';
            }
            if( themecss.backgroundcolor.length ){
                themeStyles += ' background-color: ' + themecss.backgroundcolor + '; } ';
            } else if( themecss.textcolor1.length ){
                themeStyles += ' } ';
            }

            //pagination - box and text
            themeStyles += classContainer + ' .pagination>li>a, .pagination>li>span { ';
            if( themecss.textcolor1.length ){
                themeStyles += ' color: ' + themecss.textcolor1 + '; ';
                themeStyles += ' border: 1px solid ' + themecss.textcolor1 + '; ';
            }
            if( themecss.backgroundcolor.length ){
                themeStyles += ' background-color: ' + themecss.backgroundcolor + '; ';
            }
            themeStyles += '}';

            //pagination - selected page
            themeStyles += classContainer + ' .pagination>.active>a, ' +
                            '.pagination>.active>a:focus, ' +
                            '.pagination>.active>a:hover, ' +
                            '.pagination>.active>span, ' +
                            '.pagination>.active>span:focus, ' +
                            '.pagination>.active>span:hover { ';
            if( themecss.buttontextcolor.length ){
                themeStyles += ' color: ' + themecss.buttontextcolor + '; ';
            }
            if( themecss.buttoncolor.length ){
                themeStyles += ' background-color: ' + themecss.buttoncolor + '; ';
                themeStyles += ' border-color: ' + themecss.textcolor1 + '; ';
            }
            themeStyles += '}';

            //pagination - disabled links
            themeStyles += classContainer + ' .pagination>.disabled>a, ' +
                            '.pagination>.disabled>a:focus, ' +
                            '.pagination>.disabled>a:hover, ' +
                            '.pagination>.disabled>span, ' +
                            '.pagination>.disabled>span:focus, ' +
                            '.pagination>.disabled>span:hover { ';
            if( themecss.textcolor1.length ){
                themeStyles += ' color: ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-color: ' + themecss.textcolor1 + '; ';
            }
            if( themecss.backgroundcolor.length ){
                themeStyles += ' background-color: ' + themecss.backgroundcolor + '; ';

            }
            themeStyles += '}';

            //pagination - link hovers
            themeStyles += classContainer + ' pagination>li>a:focus, ' +
                            '.pagination>li>a:hover, ' +
                            '.pagination>li>span:focus, ' +
                            '.pagination>li>span:hover { ';
            if( themecss.buttontextcolor.length ){
                themeStyles += ' background-color: ' + themecss.buttontextcolor + '; ';
            }
            if( themecss.buttoncolor.length ){
                themeStyles += ' color: ' + themecss.buttoncolor + '; ';
            }
            themeStyles += '}';

            //Items Per Page directive override classes
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' .ipp li { color: ' + themecss.textcolor1 + ' !important; }';
                themeStyles += classContainer + ' .ipp li + li { color: ' + themecss.textcolor1 + ' !important; }';
                themeStyles += classContainer + ' .ipp li:hover:not(.active), .ipp li:active:not(.active) { color: ' + themecss.buttontextcolor + ' !important; }';
            }
            if( themecss.buttoncolor.length ){
                themeStyles += classContainer + ' .ipp li.active { ' +
                                                    ' color:' + themecss.buttontextcolor + ' !important; ' +
                                                    ' border: 1px solid ' + themecss.buttoncolor + ' !important; ' +
                                                    ' background-color: ' + themecss.buttoncolor + ' !important; }';
            }
            if( themecss.buttoncolor.length ){
                themeStyles += classContainer + ' .ipp li:hover:not(.active), .ipp li:active:not(.active) { ' +
                                                    ' border: 1px solid ' + themecss.buttontextcolor + ' !important; ' +
                                                    ' background-color: ' + themecss.buttoncolor + ' !important; }';
            }
            themeStyles += classContainer + ' .ipp li:first-child:hover:not(.active), .ipp li:first-child:active:not(.active) { ' +
                                                    ' border: none !important; ' +
                                                    ' color: ' + themecss.textcolor1 + ' !important; ' +
                                                    ' background-color: transparent !important; }';
            return themeStyles;
        };

        /**
         * Wrapper for the profilePicService method, this is so that we can easily add additional functionality specific to the participant summary later
         */
        $scope.parseProfilePicData = function(participant){
            return profilePicService.parseProfilePicData(participant);
        };

        /**
         * Update the NumPerPage var when the user clicks the Items-Per-Page directive value
         * @param {integer} count - number indicating the number of items to show on the page
         */
        $scope.setPerPage = function(count){
            if( count > 0 ){
                $scope.frmObj.numPerPage = parseInt(count);
                // when frmObj updates the filter runs and re-loads data
            }
        };

        //override the pagination template so we can update the arrows with sugicons
        $templateCache.put('template/pagination/pagination.html',
            "<ul class=\"pagination\">\n" +
            "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\"><span class=\"sugicon-arrow-left-thick\"></span></a></li>\n" +
            "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\"><span class=\"sugicon-arrow-thin-left-thin\"></span></a></li>\n" +
            "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
            "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\"><span class=\"sugicon-arrow-thin-right-thin\"></span></a></li>\n" +
            "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\"><span class=\"sugicon-arrow-right-thick\"></span></a></li>\n" +
            "</ul>");


        /************************
         MODAL WATCHERS
        ************************/
        /* Watch Pagination  - DO NOT PREFIX THESE VARS WITH $scope. (ex. $scope.pagination) */
        $scope.$watch('pagination.currentPage + pagination.numPerPage', function (){
            loadData();
        });

        /* Watch frmObj */
        $scope.$watchCollection('frmObj', function (nVal, oVal) {
            var newVal = angular.copy(nVal);
            var oldVal = angular.copy(oVal);

            // validate number per page (stop processing if empty or invalid since we must have it for proper filter/sort)
            if (!$scope.frmObj.numPerPage || $scope.frmObj.numPerPage.toString().trim() === '') {
                return;
            } else if (!(angular.isNumber(~~$scope.frmObj.numPerPage) && isFinite(~~$scope.frmObj.numPerPage)) || ~~$scope.frmObj.numPerPage <= 0) {
                SUGUtilities.showMagnificAlert($scope.strings.itemsPerPageInvalid, 'error', '', 'Sorry!');
                $scope.frmObj.numPerPage = oldVal.numPerPage;
                return;
            }

            /* Apply Filter - Filter through the data Array, NOT the filtered data */
            //$scope.participantsFiltered = $filter('orderBy')($scope.modalParticipants, $scope.frmObj.orderColumn, $scope.frmObj.direction);

            /* Update Settings in Factory */
            sugCacheFactory.set('frmObj', angular.copy($scope.frmObj) );
            prepareSettings();

            /* Apply Search Filter if Present - DeBounce directive on search field handles typing delay */
            if (newVal.searchFilter != oldVal.searchFilter) {
                loadData( true ); //force the data to reset
            } else {
                filterData();
            }
        });

        init();
    }
}());
